import React from 'react'
import './Footer.css';
export default function Footer() {
  return (
    
        <h6 className='Footer_main'>Powered By YashviTech IT Solution</h6>
   
  )
}
